
import React from 'react';
import { Wallet } from 'lucide-react';

interface InventoryHeaderProps {
  totalBalance: number;
}

const InventoryHeader: React.FC<InventoryHeaderProps> = ({ totalBalance }) => {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-semibold">My GivGo Bucks</h2>
      <div className="flex items-center bg-givgo-light text-givgo-purple rounded-full px-4 py-1">
        <Wallet className="h-4 w-4 mr-2" />
        <span className="font-medium">${totalBalance} Balance</span>
      </div>
    </div>
  );
};

export default InventoryHeader;
